import PropTypes from 'prop-types'
import React from "react"
import { Col, Card, CardBody } from "reactstrap"
import CountUp from 'react-countup';
import ReactApexChart from "react-apexcharts"

const MiniWidget = props => {
  return (
    <React.Fragment>
      {props.reports.map((report, key) => (
        <Col md={6} xl={6} key={key}>
          <Card>
            <CardBody>
              {/* <div className="float-end mt-2">
                <ReactApexChart
                  options={report.options}
                  series={report.series}
                  type= {report.charttype}
                  height={report.chartheight}
                  width={report.chartwidth}
                />
              </div> */}
              <div style={{textAlign:"center"}}>
              <p className="text-dark mb-0" style={{ fontSize:"25px"}}><span className={"text-" + report.color + " me-1"}><i className={report.icon + " me-1"}></i></span></p>
                <h4 className="mb-1 mt-1"><span style={{ fontSize:"25px"}}>{report.value}</span></h4>
                <p className="text-dark mb-0" style={{ fontSize:"15px", fontWeight:"bold"}}>{report.title}</p>
                
              </div>
              
            </CardBody>
          </Card>
        </Col>
        
      ))}
    </React.Fragment>
  )
}

export default MiniWidget

MiniWidget.propTypes = {
  reports: PropTypes.array
}